import appDownloadIcon from './header-appdownload-icon.svg';
import customerIcon from './header-customer-icon.svg';

/** Reference CDN assets (bdvegas header masks), stored locally for Alfa9 guest/header chrome. */
export const HEADER_ICON_SRC = {
  appDownload: appDownloadIcon,
  customer: customerIcon,
};
